export default {
	defaultProps: {
		anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
	},
};
